import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../get-base-url';
import { useParams } from 'react-router-dom';
import ResearchDeathNotificationResidentShared from '../../research-notifications/research-death';
import { BreadcrumbItem } from '../../breadcrumb';

interface ResearchDeathNotificationResidentCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const ResearchDeathNotificationResidentCivilStatusShared = ({
  scope,
  items,
}: ResearchDeathNotificationResidentCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/morte/residenti/cancellazione`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <ResearchDeathNotificationResidentShared
        goBackUrl={goBackUrl}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

ResearchDeathNotificationResidentCivilStatusShared.displayName =
  'Research Marriage Notifications Resident Page component';

export default ResearchDeathNotificationResidentCivilStatusShared;
